import { renderToString } from "react-dom/server";

import { createImageIcon } from "@locators/components/shared/store-locator-icons";

import { PinSensorialExperienceActiveIcon } from "@jti/brand-icons/pin-sensorial-experience-active";
import { PinSensorialExperienceDefaultIcon } from "@jti/brand-icons/pin-sensorial-experience-default";
import { UiTargetIcon } from "@jti/brand-icons/ui-target";

export const USER_LOCATION = createImageIcon(renderToString(<UiTargetIcon width={43} height={43} fill="#3567FF" />));
export const DEFAULT_MARKER = createImageIcon(
  renderToString(<PinSensorialExperienceDefaultIcon width={32} height={32} />)
);
export const ACTIVE_MARKER = createImageIcon(
  renderToString(<PinSensorialExperienceActiveIcon width={32} height={32} />)
);
